import Api from "~/service/Api";

class CreditUsageRepository {
  fetch(query = {}) {
    return Api.get("/credit-usages", query);
  }
}

export default CreditUsageRepository;
